import BaseBlockMap from './BaseBlockMap';
import MortgagesAgentsListsBlockMap from './MortgageagentslistBlockMap';


export default {
    ...BaseBlockMap,
    ...MortgagesAgentsListsBlockMap,
};
